import { useEffect } from "react";
import AgenciesHeader from "../components/agencies/AgenciesHeader";
import AgenciesHero from "../components/agencies/AgenciesHero";
import AgenciesPaths from "../components/agencies/AgenciesPaths";
import AgenciesOpportunity from "../components/agencies/AgenciesOpportunity";
import AgenciesWhiteLabel from "../components/agencies/AgenciesWhiteLabel";
import AgenciesDeliverables from "../components/agencies/AgenciesDeliverables";
import CoverageMap from "../components/landing/CoverageMap";
import AgenciesFAQ from "../components/agencies/AgenciesFAQ";
import GoogleReviews from "../components/landing/GoogleReviews";
import LeadForm from "../components/landing/LeadForm";
import Footer from "../components/landing/Footer";
import MobileCTA from "../components/landing/MobileCTA";

export default function AgenciesPage() {
  useEffect(() => {
    document.title = "Galvani Studios | Productora de VideoPodcast white label para agencias";
  }, []);

  return (
    <div className="min-h-screen bg-galvani-bg">
      <AgenciesHeader />
      <main>
        <AgenciesHero />
        <AgenciesPaths />
        <AgenciesOpportunity />
        <AgenciesWhiteLabel />
        <AgenciesDeliverables />
        <CoverageMap variant="agencias" />
        <GoogleReviews />
        <LeadForm variant="agencias" />
        <AgenciesFAQ />
      </main>
      <Footer />
      <MobileCTA label="Quiero más información" />
    </div>
  );
}
